import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';

import { Logo } from '../Logo/Logo';
import styles from './index.module.css';

export const Loader = ({ size, loading, showLogo, marginTop, marginBottom }) =>
  loading && (
    <div className={styles.spinnerWrapper} role="progressbar">
      {showLogo && (
        <Logo
          variant="loader"
          lg
          className={styles.loaderLogo}
          marginTop={marginTop}
          marginBottom={marginBottom}
        />
      )}
      <Spin size={size || 'large'} />
    </div>
  );

Loader.propTypes = {
  size: PropTypes.string,
  loading: PropTypes.bool,
  /** Show branded logo above spinner (e.g. app-wide load). Default false to avoid duplicate on auth pages. */
  showLogo: PropTypes.bool,
  marginTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marginBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
